/* eslint-disable react/no-unescaped-entities */
import { Layout } from "components";
import { Article, SectionSmall, Section, FlexColumn } from "styles";

export default function Terms() {
	return (
		<Layout
			title="End User License Agreement"
			description="End User License Agreement for Wishbox Finance, covering install and use of the app on iPhone, iPad, Mac, and Android."
		>
			<Section>
				<Article>
					<SectionSmall>
						<FlexColumn>
							<div>
								<div>
									<div>
										<div>
											<div>
												<div>
													<div>
														<strong>END USER LICENSE AGREEMENT</strong>
													</div>
													<div>&nbsp;</div>
												</div>
											</div>
											<div>
												<strong>Last updated&nbsp;</strong> <strong>September 15, 2026</strong>
											</div>
											<div>&nbsp;</div>
										</div>
									</div>
									<div>
										<div>
											Wishbox Finance is licensed to You (End-User) by Kostas Filios, located and
											registered at, Athens, Greece&nbsp;("<strong>Licensor</strong>"), for use only
											under the terms of this License Agreement.
										</div>
									</div>
									<div>
										<div>
											By downloading the Licensed Application from Apple's software distribution
											platform ("App Store") and Google's software distribution platform ("Play
											Store"), and any update thereto (as permitted by this License Agreement), You
											indicate that You agree to be bound by all of the terms and conditions of this
											License Agreement, and that You accept this License Agreement. App Store and
											Play Store are referred to in this License Agreement as "
											<strong>Services</strong>."
										</div>
									</div>
									<div>
										<div>
											The parties of this License Agreement acknowledge that the Services are not a
											Party to this License Agreement and are not bound by any provisions or
											obligations with regard to the Licensed Application, such as warranty,
											liability, maintenance and support thereof. Kostas Filios, not the Services,
											is solely responsible for the Licensed Application and the content thereof.
										</div>
									</div>
									<div>
										<div>
											This License Agreement may not provide for usage rules for the Licensed
											Application that are in conflict with the latest{" "}
											<a href="https://www.apple.com/legal/internet-services/itunes/us/terms.html">
												{" "}
												Apple Media Services Terms and Conditions{" "}
											</a>{" "}
											and{" "}
											<a href="https://play.google.com/intl/en_US/about/play-terms/">
												{" "}
												Google Play Terms of Service{" "}
											</a>{" "}
											("<strong>Usage Rules</strong>"). Kostas Filios acknowledges that it had the
											opportunity to review the Usage Rules and this License Agreement is not
											conflicting with them.
										</div>
										<div>
											Wishbox Finance when purchased or downloaded through the Services, is licensed
											to You for use only under the terms of this License Agreement. The Licensor
											reserves all rights not expressly granted to You. Wishbox Finance is to be
											used on devices that operate with Apple's operating systems ("iOS" and "Mac
											OS") or Google's operating system ("Android").
										</div>
										<div>&nbsp;</div>
									</div>
									<div>
										<div>
											<strong>
												{" "}
												<strong>1.</strong> <strong>&nbsp;THE APPLICATION</strong>{" "}
											</strong>
										</div>
										<div>&nbsp;</div>
									</div>
									<div>
										<div>
											Wishbox Finance ("<strong>Licensed Application</strong>") is a piece of
											software created to Help with personal budget tracking &mdash; and customized
											for iOS and Android mobile devices ("<strong>Devices</strong>"). It is used to
											Manage personal budget.
										</div>
										<div>
											The Licensed Application is not tailored to comply with industry-specific
											regulations (Health Insurance Portability and Accountability Act (HIPAA),
											Federal Information Security Management Act (FISMA), etc.), so if your
											interactions would be subjected to such laws, you may not use this Licensed
											Application. You may not use the Licensed Application in a way that would
											violate the Gramm-Leach-Bliley Act (GLBA).
										</div>
										<div>&nbsp;</div>
										<div>
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>2. SCOPE OF LICENSE</strong>{" "}
												</strong>{" "}
											</strong>
										</div>
										<div>&nbsp;</div>
									</div>
									<div>
										<div>
											2.1 You are given a non-transferable, non-exclusive, non-sublicensable license
											to install and use the Licensed Application on any Devices that You (End-User)
											own or control and as permitted by the Usage Rules, with the exception that
											such Licensed Application may be accessed and used by other accounts
											associated with You (End-User, The Purchaser) via Family Sharing or volume
											purchasing.
										</div>
										<div>
											2.2 This license will also govern any updates of the Licensed Application
											provided by Licensor that replace, repair, and/or supplement the first
											Licensed Application, unless a separate license is provided for such update,
											in which case the terms of that new license will govern.
										</div>
										<div>
											2.3 You may not share or make the Licensed Application available to third
											parties (unless to the degree allowed by the Usage Rules, and with Kostas
											Filios's prior written consent), sell, rent, lend, lease or otherwise
											redistribute the Licensed Application.
										</div>
										<div>
											2.4 You may not reverse engineer, translate, disassemble, integrate,
											decompile, remove, modify, combine, create derivative works or updates of,
											adapt, or attempt to derive the source code of the Licensed Application, or
											any part thereof (except with Kostas Filios's prior written consent).
										</div>
										<div>
											2.5 You may not copy (excluding when expressly authorized by this license and
											the Usage Rules) or alter the Licensed Application or portions thereof. You
											may create and store copies only on devices that You own or control for backup
											keeping under the terms of this license, the Usage Rules, and any other terms
											and conditions that apply to the device or software used. You may not remove
											any intellectual property notices. You acknowledge that no unauthorized third
											parties may gain access to these copies at any time. If you sell your Devices
											to a third party, you must remove the Licensed Application from the Devices
											before doing so.
										</div>
										<div>
											2.6 Violations of the obligations mentioned above, as well as the attempt of
											such infringement, may be subject to prosecution and damages.
										</div>
										<div>
											2.7 Licensor reserves the right to modify the terms and conditions of
											licensing.
										</div>
										<div>
											2.8 Nothing in this license should be interpreted to restrict third-party
											terms. When using the Licensed Application, You must ensure that You comply
											with applicable third-party terms and conditions.
										</div>
										<div>&nbsp;</div>
									</div>
									<div>
										<div>
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>3. TECHNICAL REQUIREMENTS</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>
										</div>
										<div>&nbsp;</div>
										<div>
											3.1 The Licensed Application requires a firmware version 1.0.0 or higher.
											Licensor recommends using the latest version of the firmware.
										</div>
										<div>
											3.2 Licensor attempts to keep the Licensed Application updated so that it
											complies with modified/new versions of the firmware and new hardware. You are
											not granted rights to claim such an update.
										</div>
										<div>
											3.3 You acknowledge that it is Your responsibility to confirm and determine
											that the app end-user device on which You intend to use the Licensed
											Application satisfies the technical specifications mentioned above.
										</div>
										<div>
											3.4 Licensor reserves the right to modify the technical specifications as it
											sees appropriate at any time.
										</div>
										<div>&nbsp;</div>
										<div>
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>4. MAINTENANCE AND SUPPORT</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>
										</div>
										<div>&nbsp;</div>
										<div>
											4.1 The Licensor is solely responsible for providing any maintenance and
											support services for this Licensed Application. You can reach the Licensor at
											the email address listed in the App Store or Play Store Overview for this
											Licensed Application.
										</div>
										<div>
											4.2 Kostas Filios&nbsp;and the End-User acknowledge that the Services have no
											obligation whatsoever to furnish any maintenance and support services with
											respect to the Licensed Application.
										</div>
										<div>&nbsp;</div>
										<div>
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>5. USE OF DATA</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>
										</div>
										<div>&nbsp;</div>
										<div>
											You acknowledge that Licensor will be able to access and adjust Your
											downloaded Licensed Application content and Your personal information, and
											that Licensor's use of such material and information is subject to Your legal
											agreements with Licensor and Licensor's privacy policy:{" "}
											<a href="https://wishboxapp.com/privacy">https://wishboxapp.com/privacy</a>.
										</div>
										<div>
											You acknowledge that the Licensor may periodically collect and use technical
											data and related information about your device, system, and application
											software, and peripherals, offer product support, facilitate the software
											updates, and for purposes of providing other services to you (if any) related
											to the Licensed Application. Licensor may also use this information to improve
											its products or to provide services or technologies to you, as long as it is
											in a form that does not personally identify you.
										</div>
										<div>&nbsp;</div>
										<div>
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>5A. AI ASSISTANT AND THIRD-PARTY PROCESSING</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>
										</div>
										<div>&nbsp;</div>
										<div>
											Wishbox Assistant is an optional feature of the Licensed Application. It is
											powered by OpenAI and requires a Wishbox+ subscription and your explicit
											consent in the app. You may revoke consent in Settings → AI Assistant.
											Wishbox+ includes up to 20 Wishbox Assistant requests per day. Unused requests
											do not carry over, and we may change this limit.
										</div>
										<div>
											When you use Wishbox Assistant, your messages (including voice you send
											through the microphone) and the app data needed to answer them (which may
											include transaction amounts, dates, descriptions, categories, wishbox or
											source titles, aggregated statistics, and import samples) are sent to our
											servers and to OpenAI for processing. Voice recordings are used to transcribe
											your speech to text and are not stored on our servers. The transcript is
											treated as a message you sent. Details are in the privacy policy:{" "}
											<a href="https://wishboxapp.com/privacy">https://wishboxapp.com/privacy</a>.
										</div>
										<div>
											Assistant replies can be incomplete or incorrect. Wishbox Assistant is not
											financial, tax, legal, or investment advice. You remain responsible for the
											data you type, speak, or import and for any actions you take based on
											assistant output. You must also comply with OpenAI's applicable terms when
											using this feature.
										</div>
										<div>&nbsp;</div>
										<div>
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>5B. CLOUD SYNC</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>
										</div>
										<div>&nbsp;</div>
										<div>
											Cloud Sync is an optional feature of the Licensed Application. It requires
											Wishbox+ and stores a copy of your app database in an iCloud or Google Drive
											account you connect. Wishbox does not host that file. You must comply with
											that provider's terms. The newest copy wins across devices, and restoring a
											cloud copy can replace data on a device. Disconnecting stops new uploads from
											that device; it does not delete the remote file. You are responsible for
											access to that account and for deleting the Wishbox Sync files there if you
											want them removed. We do not warrant the availability, quota, or security of
											those third-party services. Details are in the privacy policy:{" "}
											<a href="https://wishboxapp.com/privacy">https://wishboxapp.com/privacy</a>.
										</div>
										<div>&nbsp;</div>
										<div>
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>6. USER-GENERATED CONTRIBUTIONS</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>
										</div>
										<div>&nbsp;</div>
										<div>
											The Licensed Application may invite you to chat, contribute to, or participate
											in blogs, message boards, online forums, and other functionality, and may
											provide you with the opportunity to create, submit, post, display, transmit,
											perform, publish, distribute, or broadcast content and materials to us or in
											the Licensed Application, including but not limited to text, writings, video,
											audio, photographs, graphics, comments, suggestions, or personal information
											or other material (collectively, "Contributions"). Contributions may be
											viewable by other users of the Licensed Application and through third-party
											websites or applications. As such, any Contributions you transmit may be
											treated as non-confidential and non-proprietary. When you create or make
											available any Contributions, you thereby represent and warrant that:
										</div>
										<div>
											1. The creation, distribution, transmission, public display, or performance,
											and the accessing, downloading, or copying of your Contributions do not and
											will not infringe the proprietary rights, including but not limited to the
											copyright, patent, trademark, trade secret, or moral rights of any third
											party.
										</div>
										<div>
											2. You are the creator and owner of or have the necessary licenses, rights,
											consents, releases, and permissions to use and to authorize us, the Licensed
											Application, and other users of the Licensed Application to use your
											Contributions in any manner contemplated by the Licensed Application and this
											License Agreement.
										</div>
										<div>
											3. You have the written consent, release, and/or permission of each and every
											identifiable individual person in your Contributions to use the name or
											likeness or each and every such identifiable individual person to enable
											inclusion and use of your Contributions in any manner contemplated by the
											Licensed Application and this License Agreement.
										</div>
										<div>4. Your Contributions are not false, inaccurate, or misleading.</div>
										<div>
											5. Your Contributions are not unsolicited or unauthorized advertising,
											promotional materials, pyramid schemes, chain letters, spam, mass mailings, or
											other forms of solicitation.
										</div>
										<div>
											6. Your Contributions are not obscene, lewd, lascivious, filthy, violent,
											harassing, libelous, slanderous, or otherwise objectionable (as determined by
											us).
										</div>
										<div>
											7. Your Contributions do not ridicule, mock, disparage, intimidate, or abuse
											anyone.
										</div>
										<div>
											8. Your Contributions are not used to harass or threaten (in the legal sense
											of those terms) any other person and to promote violence against a specific
											person or class of people.
										</div>
										<div>
											9. Your Contributions do not violate any applicable law, regulation, or rule.
										</div>
										<div>
											10. Your Contributions do not violate the privacy or publicity rights of any
											third party.
										</div>
										<div>
											11. Your Contributions do not violate any applicable law concerning child
											pornography, or otherwise intended to protect the health or well-being of
											minors.
										</div>
										<div>
											12. Your Contributions do not include any offensive comments that are
											connected to race, national origin, gender, sexual preference, or physical
											handicap.
										</div>
										<div>
											13. Your Contributions do not otherwise violate, or link to material that
											violates, any provision of this License Agreement, or any applicable law or
											regulation.
										</div>
										<div>
											Any use of the Licensed Application in violation of the foregoing violates
											this License Agreement and may result in, among other things, termination or
											suspension of your rights to use the Licensed Application.
										</div>
										<div>&nbsp;</div>
										<div>
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>7. CONTRIBUTION LICENSE</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>
										</div>
										<div>&nbsp;</div>
										<div>
											By posting your Contributions to any part of the Licensed Application or
											making Contributions accessible to the Licensed Application by linking your
											account from the Licensed Application to any of your social networking
											accounts, you automatically grant, and you represent and warrant that you have
											the right to grant, to us an unrestricted, unlimited, irrevocable, perpetual,
											non-exclusive, transferable, royalty-free, fully-paid, worldwide right, and
											license to host, use copy, reproduce, disclose, sell, resell, publish, broad
											cast, retitle, archive, store, cache, publicly display, reformat, translate,
											transmit, excerpt (in whole or in part), and distribute such Contributions
											(including, without limitation, your image and voice) for any purpose,
											commercial advertising, or otherwise, and to prepare derivative works of, or
											incorporate in other works, such as Contributions, and grant and authorize
											sublicenses of the foregoing. The use and distribution may occur in any media
											formats and through any media channels.
										</div>
										<div>
											This license will apply to any form, media, or technology now known or
											hereafter developed, and includes our use of your name, company name, and
											franchise name, as applicable, and any of the trademarks, service marks, trade
											names, logos, and personal and commercial images you provide. You waive all
											moral rights in your Contributions, and you warrant that moral rights have not
											otherwise been asserted in your Contributions.
										</div>
										<div>
											We do not assert any ownership over your Contributions. You retain full
											ownership of all of your Contributions and any intellectual property rights or
											other proprietary rights associated with your Contributions. We are not liable
											for any statements or representations in your Contributions provided by you in
											any area in the Licensed Application. You are solely responsible for your
											Contributions to the Licensed Application and you expressly agree to exonerate
											us from any and all responsibility and to refrain from any legal action
											against us regarding your Contributions.
										</div>
										<div>
											We have the right, in our sole and absolute discretion, (1) to edit, redact,
											or otherwise change any Contributions; (2) to recategorize any Contributions
											to place them in more appropriate locations in the Licensed Application; and
											(3) to prescreen or delete any Contributions at any time and for any reason,
											without notice. We have no obligation to monitor your Contributions.
										</div>
										<div>&nbsp;</div>
										<div>
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>8. LIABILITY</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>
										</div>
										<div>&nbsp;</div>
										<div>
											8.1 Licensor's responsibility in the case of violation of obligations and tort
											shall be limited to intent and gross negligence. Only in case of a breach of
											essential contractual duties (cardinal obligations), Licensor shall also be
											liable in case of slight negligence. In any case, liability shall be limited
											to the foreseeable, contractually typical damages. The limitation mentioned
											above does not apply to injuries to life, limb, or health.
										</div>
										<div>
											8.2 Licensor takes no accountability or responsibility for any damages caused
											due to a breach of duties according to Section 2 of this License Agreement. To
											avoid data loss, You are required to make use of backup functions of the
											Licensed Application to the extent allowed by applicable third-party terms and
											conditions of use. You are aware that in case of alterations or manipulations
											of the Licensed Application, You will not have access to the Licensed
											Application.
										</div>
										<div>&nbsp;</div>
										<div>
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>9. WARRANTY</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>
										</div>
										<div>&nbsp;</div>
									</div>
								</div>
								<div>
									9.1 Licensor warrants that the Licensed Application is free of spyware, trojan
									horses, viruses, or any other malware at the time of Your download. Licensor
									warrants that the Licensed Application works as described in the user
									documentation.
								</div>
								<div>
									9.2 No warranty is provided for the Licensed Application that is not executable on
									the device, that has been unauthorizedly modified, handled inappropriately or
									culpably, combined or installed with inappropriate hardware or software, used with
									inappropriate accessories, regardless if by Yourself or by third parties, or if
									there are any other reasons outside of Kostas Filios's sphere of influence that
									affect the executability of the Licensed Application.
								</div>
								<div>
									9.3 You are required to inspect the Licensed Application immediately after
									installing it and notify Kostas Filios about issues discovered without delay by
									email provided in&nbsp; <a href="#productclaims">Product Claims</a>. The defect
									report will be taken into consideration and further investigated if it has been
									emailed within a period of sixty (60) days after discovery.
								</div>
								<div>
									9.4 If we confirm that the Licensed Application is defective, Kostas Filios
									reserves a choice to remedy the situation either by means of solving the defect or
									substitute delivery.
								</div>
								<div>
									<div>
										9.5 In the event of any failure of the Licensed Application to conform to any
										applicable warranty, You may notify the Services Store Operator, and Your
										Licensed Application purchase price will be refunded to You. To the maximum
										extent permitted by applicable law, the Services Store Operator will have no
										other warranty obligation whatsoever with respect to the Licensed Application,
										and any other losses, claims, damages, liabilities, expenses, and costs
										attributable to any negligence to adhere to any warranty.
									</div>
								</div>
								<div>
									<div>
										9.6 If the user is an entrepreneur, any claim based on faults expires after a
										statutory period of limitation amounting to twelve (12) months after the
										Licensed Application was made available to the user. The statutory periods of
										limitation given by law apply for users who are consumers.
									</div>
									<div>&nbsp;</div>
								</div>
								<div>
									<div>
										<strong>
											{" "}
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>
															{" "}
															<strong>
																{" "}
																<strong>
																	{" "}
																	<strong>
																		{" "}
																		<strong>10. PRODUCT CLAIMS</strong>{" "}
																	</strong>{" "}
																</strong>{" "}
															</strong>{" "}
														</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>{" "}
										</strong>
									</div>
									<div>&nbsp;</div>
								</div>
								<div>
									<div>
										Kostas Filios&nbsp;and the End-User acknowledge that Kostas Filios, and not the
										Services, is responsible for addressing any claims of the End-User or any third
										party relating to the Licensed Application or the End-User&rsquo;s possession
										and/or use of that Licensed Application, including, but not limited to:
									</div>
								</div>
								<div>
									<div>(i) product liability claims;</div>
								</div>
								<div>
									<div>
										(ii) any claim that the Licensed Application fails to conform to any applicable
										legal or regulatory requirement; and
									</div>
								</div>
								<div>
									<div>
										(iii) claims arising under consumer protection, privacy, or similar legislation.
									</div>
									<div>&nbsp;</div>
								</div>
								<div>
									<div>
										<strong>
											{" "}
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>
															{" "}
															<strong>
																{" "}
																<strong>
																	{" "}
																	<strong>
																		{" "}
																		<strong>
																			{" "}
																			<strong>11. LEGAL COMPLIANCE</strong>{" "}
																		</strong>{" "}
																	</strong>{" "}
																</strong>{" "}
															</strong>{" "}
														</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>{" "}
										</strong>
									</div>
									<div>&nbsp;</div>
								</div>
								<div>
									<div>
										You represent and warrant that You are not located in a country that is subject
										to a US Government embargo, or that has been designated by the US Government as
										a "terrorist supporting" country; and that You are not listed on any US
										Government list of prohibited or restricted parties.
									</div>
									<div>&nbsp;</div>
								</div>
								<div>
									<div>
										<strong>
											{" "}
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>
															{" "}
															<strong>
																{" "}
																<strong>
																	{" "}
																	<strong>
																		{" "}
																		<strong>
																			{" "}
																			<strong>
																				{" "}
																				<strong>
																					{" "}
																					<strong>12. CONTACT INFORMATION</strong>{" "}
																				</strong>{" "}
																			</strong>{" "}
																		</strong>{" "}
																	</strong>{" "}
																</strong>{" "}
															</strong>{" "}
														</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>{" "}
										</strong>
									</div>
									<div>&nbsp;</div>
								</div>
								<div>
									<div>
										For general inquiries, complaints, questions or claims concerning the Licensed
										Application, please contact:
									</div>
									<div>Kostas Filios</div>
									<div>
										<strong>
											<a href="mailto:wishboxappinfo@gmail.com">wishboxappinfo@gmail.com</a>
										</strong>
									</div>
									<div>&nbsp;</div>
								</div>
							</div>
							<div>
								<div>
									<strong>
										{" "}
										<strong>
											{" "}
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>
															{" "}
															<strong>
																{" "}
																<strong>
																	{" "}
																	<strong>
																		{" "}
																		<strong>
																			{" "}
																			<strong>13. TERMINATION</strong>{" "}
																		</strong>{" "}
																	</strong>{" "}
																</strong>{" "}
															</strong>{" "}
														</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>{" "}
										</strong>{" "}
									</strong>
								</div>
								<div>&nbsp;</div>
							</div>
							<div>
								<div>
									The license is valid until terminated by Kostas Filios or by You. Your rights
									under this license will terminate automatically and without notice from Kostas
									Filios if You fail to adhere to any term(s) of this license. Upon License
									termination, You shall stop all use of the Licensed Application, and destroy all
									copies, full or partial, of the Licensed Application.
								</div>
								<div>&nbsp;</div>
							</div>
							<div>
								<div>
									<strong>
										{" "}
										<strong>
											{" "}
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>
															{" "}
															<strong>
																{" "}
																<strong>
																	{" "}
																	<strong>
																		{" "}
																		<strong>
																			{" "}
																			<strong>
																				{" "}
																				<strong>
																					{" "}
																					<strong>
																						{" "}
																						<strong>
																							14. THIRD-PARTY TERMS OF AGREEMENTS AND BENEFICIARY
																						</strong>{" "}
																					</strong>{" "}
																				</strong>{" "}
																			</strong>{" "}
																		</strong>{" "}
																	</strong>{" "}
																</strong>{" "}
															</strong>{" "}
														</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>{" "}
										</strong>{" "}
									</strong>
								</div>
								<div>&nbsp;</div>
							</div>
							<div>
								<div>
									Kostas Filios represents and warrants that Kostas Filios will comply with
									applicable third-party terms of agreement when using Licensed Application.
								</div>
							</div>
							<div>
								<div>
									In Accordance with Section 9 of the "Instructions for Minimum Terms of Developer's
									End-User License Agreement," both Apple and Google and their subsidiaries shall be
									third-party beneficiaries of this End User License Agreement and &mdash; upon Your
									acceptance of the terms and conditions of this License Agreement, both Apple and
									Google will have the right (and will be deemed to have accepted the right) to
									enforce this End User License Agreement against You as a third-party beneficiary
									thereof.
								</div>
								<div>&nbsp;</div>
							</div>
							<div>
								<div>
									<strong>
										{" "}
										<strong>
											{" "}
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>
															{" "}
															<strong>
																{" "}
																<strong>
																	{" "}
																	<strong>
																		{" "}
																		<strong>
																			{" "}
																			<strong>
																				{" "}
																				<strong>
																					{" "}
																					<strong>15. INTELLECTUAL PROPERTY RIGHTS</strong>{" "}
																				</strong>{" "}
																			</strong>{" "}
																		</strong>{" "}
																	</strong>{" "}
																</strong>{" "}
															</strong>{" "}
														</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>{" "}
										</strong>{" "}
									</strong>
								</div>
								<div>&nbsp;</div>
							</div>
							<div>
								<div>
									Kostas Filios and the End-User acknowledge that, in the event of any third-party
									claim that the Licensed Application or the End-User's possession and use of that
									Licensed Application infringes on the third party's intellectual property rights,
									Kostas Filios, and not the Services, will be solely responsible for the
									investigation, defense, settlement, and discharge or any such intellectual
									property infringement claims.
								</div>
								<div>&nbsp;</div>
							</div>
							<div>
								<div>
									<strong>
										{" "}
										<strong>
											{" "}
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>
															{" "}
															<strong>
																{" "}
																<strong>
																	{" "}
																	<strong>
																		{" "}
																		<strong>
																			{" "}
																			<strong>
																				{" "}
																				<strong>
																					{" "}
																					<strong>
																						{" "}
																						<strong>16. APPLICABLE LAW</strong>{" "}
																					</strong>{" "}
																				</strong>{" "}
																			</strong>{" "}
																		</strong>{" "}
																	</strong>{" "}
																</strong>{" "}
															</strong>{" "}
														</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>{" "}
										</strong>{" "}
									</strong>
								</div>
								<div>&nbsp;</div>
							</div>
							<div>
								<div>
									This License Agreement is governed by the laws of Greece excluding its conflicts
									of law rules.
								</div>
								<div>&nbsp;</div>
							</div>
							<div>
								<div>
									<strong>
										{" "}
										<strong>
											{" "}
											<strong>
												{" "}
												<strong>
													{" "}
													<strong>
														{" "}
														<strong>
															{" "}
															<strong>
																{" "}
																<strong>
																	{" "}
																	<strong>
																		{" "}
																		<strong>
																			{" "}
																			<strong>
																				{" "}
																				<strong>
																					{" "}
																					<strong>
																						{" "}
																						<strong>
																							{" "}
																							<strong>17. MISCELLANEOUS</strong>{" "}
																						</strong>{" "}
																					</strong>{" "}
																				</strong>{" "}
																			</strong>{" "}
																		</strong>{" "}
																	</strong>{" "}
																</strong>{" "}
															</strong>{" "}
														</strong>{" "}
													</strong>{" "}
												</strong>{" "}
											</strong>{" "}
										</strong>{" "}
									</strong>
								</div>
								<div>&nbsp;</div>
								<div>
									<div>
										17.1 If any of the terms of this agreement should be or become invalid, the
										validity of the remaining provisions shall not be affected. Invalid terms will
										be replaced by valid ones formulated in a way that will achieve the primary
										purpose.
									</div>
									<div>
										17.2 Collateral agreements, changes and amendments are only valid if laid down
										in writing. The preceding clause can only be waived in writing.
									</div>
								</div>
							</div>
						</FlexColumn>
					</SectionSmall>
				</Article>
			</Section>
		</Layout>
	);
}
